/**
 * Full-text search over title, notes and text props (spec §18 adopted: MUST, M2), with the one text match of the
 * app (`core/textMatch.ts`, UI cleanup U2): every word of the query occurs, ignoring case. Hits whose title matches
 * come first. The server keeps a `tsvector` on `mat_task` for API queries.
 */
import type { Task } from "../core/schema";
import { matchesText } from "../core/textMatch";

export interface SearchHit {
  id: string;
  title: string;
  typeId: string;
  done: boolean;
}

export class TaskSearch {
  private tasks: { task: Task; props: string }[] = [];

  rebuild(tasks: Task[]): void {
    this.tasks = tasks
      .filter((t) => !t.archivedAt)
      .map((task) => ({
        task,
        props: Object.values(task.props)
          .filter((v) => typeof v === "string")
          .join(" "),
      }));
  }

  search(q: string, limit = 12): SearchHit[] {
    if (!q.trim()) return [];
    const inTitle: Task[] = [];
    const elsewhere: Task[] = [];
    for (const { task, props } of this.tasks) {
      if (matchesText([task.title], q)) inTitle.push(task);
      else if (matchesText([task.title, task.notes, props], q)) elsewhere.push(task);
      if (inTitle.length >= limit) break;
    }
    return [...inTitle, ...elsewhere]
      .slice(0, limit)
      .map((t) => ({ id: t.id, title: t.title, typeId: t.typeId, done: t.doneAt !== null }));
  }
}
